import styled from "styled-components"

export const IconTooltipStyle = styled.div`
  .flex {
    display: flex;
  }

  .justify-center {
    justify-content: center;
  }

  .items-center {
    align-items: center;
  }

  .rounded-md {
    border-radius: 0.375rem;
  }

  .drop-shadow-xl {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  }

  .bg-discord {
    background-color: #7289da;
  }

  .from-gray-800 {
    background-color: #2f3136;
  }

  .to-black {
    background-color: rgb(63 172 221);
  }

  .text-white {
    color: #ffffff;
  }

  .font-semibold {
    font-weight: 600;
  }

  .hover-rounded-circle:hover {
    border-radius: 50%;
  }

  .transition-all {
    transition-property: all;
  }

  .duration-500 {
    transition-duration: 0.5s;
  }

  .hover-from-331029:hover {
    background-color: #331029;
  }

  .hover-to-310413:hover {
    background-color: #310413;
  }

  .relative {
    position: relative;
  }

  .pointer-events-none {
    pointer-events: none;
  }

  .absolute {
    position: absolute;
  }

  .opacity-0 {
    opacity: 0;
  }

  .group-hover-opacity-100:hover {
    opacity: 1;
  }

  .group-hover-text-gray-700:hover {
    color: #4b5563;
  }

  .group-hover-text-sm:hover {
    font-size: 0.875rem;
  }

  .group-hover-translate-y-10:hover {
    transform: translateY(-1.25rem);
  }

  .duration-700 {
    transition-duration: 0.7s;
  }
`;
export const StyledBox = styled.div`
/* .boxMain {
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    
    background-color: #ffffff;
    box-shadow: 0 0 5px 5px rgba(0,0,0,0.03);
    margin: 5px;
} */
`